import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

export const MenuArrow = styled.svg`
  display: block;
  float: right;
  margin-top: 1.25rem;
  width: 20px;
  height: 20px;
  transition: all 0.3s linear;
  transform: ${props => props.expandMenu ? 'rotate(180deg)' : 'rotate(0deg)'};

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: inline-block;
    float: none;
    width: 11px;
    height: 16px;
    margin-top: 0;
    margin-left: 0.6rem;
    vertical-align: middle;
    transform: rotate(0deg);
  }
`

export const MenuLink = styled(Link)`
  display: block;
  width: 100%;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.mobilefont ? '1.4rem' : '2rem'};
  font-weight: 300;
  line-height: 2.4;
  cursor: pointer;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: inline;
    width: auto;
    color: ${props => props.lighttheme ? props.theme.colors.white : props.theme.colors.darkGrey};
    padding-bottom: 0.5rem;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: normal;
  }
`

export const LinkContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: inline-block;
    width: auto;
    margin-left: 4rem;
    border-bottom: 1px solid transparent;

    &:hover,
    &:active,
    &:focus {
      ${MenuArrow} {
        transform: rotate(180deg);
      }
    }

    &:first-child {
      margin-left: auto;
    }
  }
`

export const ChildLinkContainer = styled.div`
         position: relative;
         max-height: ${props => (props.expandMenu ? '17rem' : '0')};
         overflow: hidden;
         transition: max-height 0.3s linear;

         @media screen and (min-width: ${props =>
    props.theme.responsive.medium}) {
           display: none;
           position: absolute;
           padding-top: 1.8rem;
           overflow: visible;
           max-height: none;

           ${LinkContainer} {
             display: block;
             float: left;
             clear: left;
             margin-top: 1.5rem;
             margin-left: 0;

             &:first-child {
               margin-top: 0;
             }
           }

           ${LinkContainer}:hover & {
             display: block;
             left: -2rem;
             padding: 2.5rem 2rem 2rem;
             width: 130%;
             background-color: #171717;
             margin-top: 8px;
           }
         }

         ${MenuLink} {
           display: block;
           font-size: 1.6rem;
           line-height: 2.25;
           margin-left: 1.5rem;

           @media screen and (min-width: ${props =>
    props.theme.responsive.medium}) {
             margin-left: 0;
             font-size: 1.4rem;
             line-height: normal;
           }
         }

         ${props =>
    props.sticky &&
           css`
             background-color: white !important;

             @media screen and (min-width: ${props =>
    props.theme.responsive.medium}) {
               ${LinkContainer} {
                 margin-top: 1rem;

                 &:first-child {
                   margin-top: 0;
                 }
               }

               ${LinkContainer}:hover & {
                 left: -2rem;
                 padding: 2.5rem 2rem 2rem;
                 width: 130%;
               }
             }
           `}
       `
